import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { Server } from "App";

const Billing = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [billingStatus, setBillingStatus] = useState("");
  const [plan, setPlan] = useState("");
  const [transactions, setTransactions] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      getUser();
    } else {
      navigate("/employers");
    }
  }, []);

  const getUser = async () => {
    try {
      const decoded = jwtDecode(token);
      let { data } = await axios.get(
        `${Server}/api/v1/employer/${decoded?.userId}`
      );
      data = data?.Employer[0];
      if (data?.subscribed) {
        if (data?.access) {
          setBillingStatus("Recruiter Access");
          setPlan("Recommended");
        } else {
         setPlan(data?.plan)
          fetchBillingDetails(data?.stripeCustomerId);
        }
      } else {
        setBillingStatus("Not Subscribed");
      }

      setLoading(false);
    } catch (error) {
      console.error(error);
      setBillingStatus("Error");
      toast.error("Something went wrong.");
      setLoading(false);
    }
  };

  const fetchBillingDetails = async (customerId) => {
    try {
      // Fetch Plan Details
      // const planResponse = await axios.get(
      //   `${Server}/api/v1/subscribe/get/plan?customerId=${customerId}`
      // );
      // console.log(planResponse)
      // setPlan(planResponse.data?.plan?.name || "No active plan");

      // Fetch Transactions
      const transactionResponse = await axios.get(
        `${Server}/api/v1/subscribe/get/transaction?customerId=${customerId}`
      );
      console.log(transactionResponse)
      setTransactions(transactionResponse.data?.transactions || []);
    } catch (error) {
      console.error("Error fetching billing details:", error);
      toast.error("Failed to load billing details.");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <>
      <section>
        <Toaster position="top-center" reverseOrder={false} />
        <br />
        <div className="upper-title-box">
          <h3>Billing Information</h3>
          <p className="text">
            Manage your subscription and transactions here.
          </p>
        </div>

        <div className="plan-card-container">
          <div className="plan-card">
            <h2 className="plan-title">Your Billing Information</h2>
            <div className="plan-content">
              {plan?<div className="current-plan-label">{plan==="Recommended"?`Premium`:plan}</div>:null}
              <div className="plan-details">
                <h3 className="plan-name">{plan?plan==="Recommended"?`Premium Plan`:`${plan} Plan`:"No Active Plan"}</h3>

                {billingStatus === "Recruiter Access" ? (
                  <p className="plan-description">
                    You have full access provided by the admin. <br />
                    <strong>
                      All billing and transactions are managed by the admin.
                    </strong>
                  </p>
                ) : billingStatus === "Not Subscribed" ? (
                  <p className="plan-description">
                    You do not have an active subscription.{" "}
                    <a href="/pricing" className="plan-link">
                      Subscribe now
                    </a>
                    .
                  </p>
                ) : (
                  <p className="plan-description">
                   Subscription has full access to all features.{" "}
                    <a  onClick={()=>navigate("/pricing")} className="plan-link">
                      View Benefits
                    </a>
                    .
                  </p>
                )}

                {billingStatus === "Not Subscribed" && (
                  <div className="plan-actions">
                    <button
                      className="subscribe-button"
                      onClick={() => navigate("/pricing")}
                    >
                      Subscribe Now
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Payment Method Section */}
   {    /* {billingStatus !== "Recruiter Access" && billingStatus !== "Not Subscribed"&&(
          <div className="plan-card-container">
            <div className="plan-card">
              <h2 className="plan-title">Payment Method</h2>
              <div className="plan-content">
                <div className="plan-details">
                  {transactions.length > 0 ? (
                    <>
                      <h3 className="plan-name">Saved Payment Method</h3>
                      <p className="plan-description">
                        Your payment details are securely stored with Stripe.
                      </p>
                    </>
                  ) : (
                    <>
                      <h3 className="plan-name">No Payment Method</h3>
                      <p className="plan-description">No cards found.</p>
                    </>
                  )}
                  <div className="plan-actions">
                    <button className="update-plan-button">+ Add Card</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}*/}

        {/* Invoice History */}
        {billingStatus !== "Recruiter Access" && billingStatus !== "Not Subscribed"&& (
          <div className="invoice-container">
            <div className="header-section">
              <h2 className="invoice-title">Invoice History</h2>
              <p className="invoice-subtitle">
                View or download your past invoices.
              </p>
            </div>

            <div className="table-container">
              <table className="invoice-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.length > 0 ? (
                    transactions.map((invoice, index) => (
                      <tr key={index}>
                        <td>
                          <a
                            href={invoice.hosted_invoice_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {new Date(
                              invoice.created * 1000
                            ).toLocaleDateString()}
                          </a>
                        </td>
                        <td>
                          <span className={`status-badge ${invoice.status}`}>
                            {invoice.status.charAt(0).toUpperCase() +
                              invoice.status.slice(1)}
                          </span>
                        </td>
                        <td className="amount">
                          ${(invoice.amount_due / 100).toFixed(2)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="3"
                        style={{ textAlign: "center", padding: "10px" }}
                      >
                        No transactions found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Billing;
